import React from "react";

import { IDownloadTypes } from "models/Order";
import IDevolutionInvoicePdfDownloadButtonProps from "./interface";

import { notaFiscalAction } from 'components/ApplicationInsights/eventNames';
import DevolutionInvoiceDownloadButton from "../DevolutionInvoiceDownloadButton";  

const DevolutionInvoicePdfDownloadButton: React.FC<IDevolutionInvoicePdfDownloadButtonProps> = (props) => {
    const { order, className } = props;
    
    return (
        <DevolutionInvoiceDownloadButton
            textButton="Download Nota de Devolução"
            trackName={notaFiscalAction.NOTA_DEVOLUCAO_PDF}
            downloadType={IDownloadTypes.DEVOLUTION_INVOICE}
            order={order}
            className={className}
        />
    );
};

export default DevolutionInvoicePdfDownloadButton;